<template>
  <div>
    <OperationDialog
      :show="showDialog"
      :opera-info="operaInfo"
      :show-content="false"
      :cancel="false"
      :show-close="false"
      @confirm="handelConfirm"
    />
  </div>
</template>

<script>
import OperationDialog from '@/components/TbbDialog/OperationDialog.vue'
import { getIsTbbaccess } from '@/utils/session';

export default {
  name: 'PlugDialog',
  components: {
    OperationDialog
  },
  data() {
    return {
      showDialog: false,
      
      operaInfo: {
        title: 'dialog.attention',
        otherDec: 'error.error_login_token'
      }
    }
  },
  created() {
    this.getSocketCmd()
    console.log('getSocketCmd')
  },
  methods: {
    getSocketCmd() {
      let cmdId = sessionStorage.getItem('socket-cmd')
      console.log(cmdId, 'cmdId')
      if(cmdId == '1003' || cmdId == '1004') {
        return;
      }
      if (cmdId) {
        if (cmdId == 1001) {
          this.operaInfo.otherDec = 'error.error_status_changed'
        } else if (cmdId == 1002) {
          this.operaInfo.otherDec = 'error.error_role_changed'
        }
        this.showDialog = true
      }  else {
        this.operaInfo.otherDec = 'error.error_login_token'
        this.showDialog = true
      }
    },
    handelConfirm() {
      this.showDialog = false
      const isTbbaccess = getIsTbbaccess()
      this.$store.dispatch('LogOut').then(() => {
        if(isTbbaccess === '1') {
          location.href = '/tbbaccess/login'
        } else {
          location.href = '/login'
        }
        
        this.$store.dispatch('setDialogConfirmBtn', false)
      })
    }
  }
}
</script>
